import { render, staticRenderFns } from "./RooftopPreviewData.vue?vue&type=template&id=2a9b4faa&"
import script from "./RooftopPreviewData.vue?vue&type=script&lang=js&"
export * from "./RooftopPreviewData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports